<template>
  <button v-if="(isTaskModuleOrder || isDeliveryScheduleModule) && !summaryPanel && (order?.resourceUid|| orderSummary?.resourceUid)" @click="openSummaryPanel"
          class="btn btn-success summary-trigger-btn">
    <span class="svg-icon">
      <svg width="25" height="28" viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.40094 3.4401V2.10677C7.40033 1.76658 7.52977 1.43903 7.76277 1.19116C7.99577 0.943285 8.3147 0.793848 8.65427 0.773438H16.0009C16.3381 0.797099 16.6538 0.947953 16.884 1.19548C17.1142 1.44301 17.2418 1.76874 17.2409 2.10677V3.4401C17.2418 3.77813 17.1142 4.10386 16.884 4.35139C16.6538 4.59892 16.3381 4.74978 16.0009 4.77344H8.65427C8.3147 4.75303 7.99577 4.60359 7.76277 4.35572C7.52977 4.10785 7.40033 3.78029 7.40094 3.4401ZM24.0009 10.3068V19.9334C24.0168 20.8755 23.847 21.8114 23.5011 22.6878C23.1552 23.5642 22.6401 24.3639 21.9851 25.0412C21.3301 25.7185 20.5481 26.2601 19.6837 26.6351C18.8194 27.0101 17.8897 27.2111 16.9476 27.2268H7.08094C5.18074 27.2022 3.36795 26.4246 2.04054 25.0646C0.713134 23.7047 -0.0204132 21.8737 0.000939745 19.9734V10.3468C-0.0270515 8.61371 0.571086 6.92871 1.68552 5.60118C2.79996 4.27366 4.35589 3.39271 6.06761 3.1201V3.4401C6.06729 4.1337 6.33724 4.80013 6.82016 5.29799C7.30309 5.79585 7.96099 6.08596 8.65427 6.10677H16.0009C16.6919 6.08257 17.3464 5.79097 17.8265 5.29348C18.3066 4.79598 18.5747 4.13147 18.5743 3.4401V3.21344C20.1405 3.62092 21.5255 4.54049 22.5088 5.82584C23.4921 7.1112 24.0174 8.68849 24.0009 10.3068ZM7.80094 15.4134L10.9743 19.3334C11.0666 19.4457 11.1826 19.5362 11.314 19.5985C11.4454 19.6607 11.5889 19.6931 11.7343 19.6934C11.8856 19.6924 12.0345 19.6557 12.1689 19.5861C12.3033 19.5166 12.4193 19.4163 12.5076 19.2934L16.8543 13.4401C16.9828 13.2317 17.0357 12.9855 17.0041 12.7427C16.9726 12.4999 16.8585 12.2754 16.6809 12.1068C16.4748 11.9647 16.2224 11.9064 15.9748 11.9435C15.7272 11.9806 15.503 12.1105 15.3476 12.3068L11.7476 17.1468L9.33427 14.1601C9.17326 13.9701 8.94633 13.8479 8.69903 13.8183C8.45172 13.7886 8.20234 13.8536 8.00094 14.0001C7.79628 14.1676 7.66209 14.4059 7.62504 14.6677C7.58799 14.9296 7.65078 15.1958 7.80094 15.4134Z"
            fill="currentColor"></path>
      </svg>
    </span>

    <label class="tw-vertical-button-text">{{ $t("order.buttons.summary") }} </label>
    <q-tooltip>{{ $t("order.tooltip.summary") }}</q-tooltip>
  </button>

  <div v-if="(isTaskModuleOrder || isDeliveryScheduleModule) && summaryPanel && (order?.resourceUid|| orderSummary?.resourceUid)" class="tw-aside-tools-inner">
    <div class="card" :style="summaryPanel ? 'right:0px; width: 40vw;' : 'right:-40vw'">
      <div class="card-header bg-white d-flex justify-content-between align-items-center" style="height: 50px">
        <div class="card-title mb-0" @click="openNewTab">
          <span class="text-primary cursor-pointer">{{ $t("order.buttons.summaryLink") }}
            <span class="bold text-primary cursor-pointer font-semi-bold" style="text-decoration: underline">
              Nº {{ $route.name === 'order' ? $store.state.orderModule.order.reference : $route.name === 'task-list' ? $store.state.summaryPanelModule.order?.reference :  order?.reference || orderSummary?.reference  }}
            </span>
          </span>
        </div>
        <span @click="openSummaryPanel" class="cursor-pointer">
          <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
              fill="currentColor"></rect>
            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor">
            </rect>
          </svg>
        </span>
      </div>
      <div class="card-body">
        <div class="row flex-start mb-3 justify-content-between flex-nowrap" style="gap: 10px">
           <q-btn :label="$t('demand.tabs.summary.label')" v-on:click="setSummary('SUMMARY')" class="btn btn-sm w-100 mr-5"
            :class="summarySelected === 'SUMMARY' ? 'btn-primary' : 'btn-outline-primary'" />
          <q-btn :label="$t('demand.tabs.conditions')" v-on:click="setSummary('CONDITION')" class="btn btn-sm w-100"
            :class="summarySelected === 'CONDITION' ? 'btn-primary' : 'btn-outline-primary'" />
          <q-btn :label="$t('demand.tabs.tiers')" v-on:click="setSummary('PARTY')" class="btn btn-sm w-100"
            :class="summarySelected === 'PARTY' ? 'btn-primary' : 'btn-outline-primary'" />

          <q-btn :label="$t('demand.tabs.asset')" v-on:click="setSummary('ASSET')" class="btn btn-sm w-100"
            :class="summarySelected === 'ASSET' ? 'btn-primary' : 'btn-outline-primary'" />

          <q-btn :label="$t('demand.tabs.preconditions')" v-on:click="setSummary('PRECONDITIONS')" class="btn btn-sm w-100"
            :class="summarySelected === 'PRECONDITIONS' ? 'btn-primary' : 'btn-outline-primary'
            " />
            <q-btn :label="$t('order.main.tabs.history')" v-on:click="setSummary('ACTIONHISTORY')" class="btn btn-sm w-100"
            :class="summarySelected === 'ACTIONHISTORY' ? 'btn-primary' : 'btn-outline-primary'
            " />
            
        </div>
        <div class="row">
          <div class="col-lg-12">
            <OrderSummary  :order="orderSummary" v-if="tabSelected === 'SUMMARY'" />
            <OrderSummaryConditions :orderConditions="orderConditions" v-if="tabSelected === 'CONDITION'" />
            <OrderSummaryParty :arrParties="parties" v-if="tabSelected === 'PARTY'" />
            <OrderSummaryAsset :assets="assets" v-else-if="tabSelected === 'ASSET'" />
            <OrderSummaryPreConditions v-else-if="tabSelected === 'PRECONDITIONS'" />
            <OrderSummarySupplier v-else-if="tabSelected === 'SUPPLIER'" />
            <SummaryMessage v-else-if="tabSelected === 'MESSAGE'" :entityState="$store.state.orderModule.order" />
            <OrderSummaryDocuments v-else-if="tabSelected === 'DOCUMENTSHISTORY'" />
            <OrderSummaryHistory v-else-if="tabSelected === 'ACTIONHISTORY'" :historiesStep="historiesStep"
            :entityState="$store.state.orderModule.order"  />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import store from "@/store";
import {Options, Vue} from "vue-class-component";
import {getOrderFromState, globalConfig, sleep} from "@/utils";
import OrderSummaryAsset from "@/components/summary-panel/order/OrderSummaryAsset.vue";
import OrderSummaryParty from "@/components/summary-panel/order/OrderSummaryParty.vue";
import OrderSummarySupplier from "@/components/summary-panel/order/OrderSummarySupplier.vue";
import SummaryMessage from "@/components/summary-panel/SummaryMessage.vue";
import OrderSummaryPreConditions from "@/components/summary-panel/order/OrderSummaryPreConditions.vue";
import OrderSummaryConditions from "@/components/summary-panel/order/OrderSummaryConditions.vue";
import OrderSummaryDocuments from "@/components/summary-panel/order/OrderSummaryDocuments.vue";
import {Notify} from "quasar";
import router from "@/router";
import { TaskModule } from "@/types";
import OrderSummary from "./OrderSummary.vue";
import OrderHistory from "@/components/order/history/OrderHistory.vue";
import OrderSummaryHistory from "./OrderSummaryHistory.vue";

@Options({
  components: {
    OrderSummaryParty,
    OrderSummaryAsset,
    OrderSummarySupplier,
    SummaryMessage,
    OrderSummaryPreConditions,
    OrderSummaryConditions,
    OrderSummary,
    OrderSummaryDocuments,
    OrderHistory,
    OrderSummaryHistory
  },
})
export default class OrderSummaryPanel extends Vue {
  summarySelected = "SUMMARY";
  order: any;

  get isTaskModuleOrder() {
    return store.getters['taskModule/isTaskModuleOrder']
  }

  get isDeliveryScheduleModule() {
    return this.$route.name === 'deliverySchedule'
  }

  get assets() {
    return store.getters['summaryPanelModule/getOrderAssets']
  }

  get parties() {
    return store.getters['summaryPanelModule/getOrderParties']
  }

  get summaryPanel() {
    return store.state.middleOfficeModule.summaryPanel;
  }

  get tabSelected() {
    return this.summarySelected ? this.summarySelected : "PARTY";
  }
  get orderConditions() {
    return this.$route.name === 'order' || this.$route.name === 'order-edit'
            ? store.state.orderModule.order.orderConditions
            : this.$route.name === 'TaskDetail'
            ? store.state.taskModule.order?.orderConditions || store.state.summaryPanelModule.order?.orderConditions
            : this.$route.name === 'task-list' || this.$route.name === 'deliverySchedule'
            ? store.state.summaryPanelModule.order?.orderConditions
            : null;
  }
   get orderSummary() {
    return store.state.summaryPanelModule.order;
  }

  get historiesStep() {
    //  TODO finish
    if (store.state.orderModule.historiesStep) {
      return store.state.orderModule.historiesStep;
    }
    return [
      {
        config: {},
        histories: [],
      },
      {
        config: {},
        histories: [],
      },
    ];
  }
  setSummary(summaryBlock: string) {
    this.summarySelected = summaryBlock;
  }

  openSummaryPanel() {
    store.state.middleOfficeModule.summaryPanel = !store.state.middleOfficeModule
      .summaryPanel;
  }

  async openNewTab() {
    const routeData = this.$route.name === 'order' 
                      ? router.resolve(`${'/order/edit/'}${store.state.orderModule.order.resourceUid}`)
                      : this.$route.name === 'task-list'
                      ? router.resolve(`${'/order/edit/'}${store.state.summaryPanelModule.order?.resourceUid}`)
                      : router.resolve(`${'/order/edit/'}${this.order?.resourceUid || store.state.summaryPanelModule.order?.resourceUid}`);
        window.open(routeData.href, "_blank");

  }
  get assignReassign() {
    return store.state.taskModule.assignReassign;
  }
  get previousRoute(){
   return store.state.taskModule.previousRoute
  }

    created() {
        if (this.isTaskModuleOrder) {

          this.order = getOrderFromState(store.state, this.$route.name);
          if (this.order?.resourceUid) {
            store.dispatch("summaryPanelModule/setSummaryOrder", { order: this.order });
          }
          if (this.$route.name === 'order') {

            this.order = store.state.orderModule.order
            if (this.order) {
              store.dispatch("summaryPanelModule/setSummaryOrder", { order: this.order });
            }
          }
          if (this.$route.name === 'task-list' ) {
            const orderId = this.assignReassign?.selectedTasks[0].variables.orderId.value
            store.dispatch("summaryPanelModule/setOrder", { orderId: orderId });
            this.order = store.state.summaryPanelModule.order
          }
          if (this.$route.name === 'TaskDetail' && !this.previousRoute) {
             const orderState = localStorage.getItem(globalConfig.storageKeys.orderTask)
             const orderId = orderState ? JSON.parse(orderState).resourceUid : ""
              store.dispatch("summaryPanelModule/setOrder", { orderId: orderId }).then(() => {
                 this.order = this.$store.state.summaryPanelModule.order
           })
          }
    }
  }

}
</script>
